import React from "react";
import DatePicker from "react-datepicker/es/index";
import styled from "styled-components";
import { Button } from "../../common/components/Button";
import { FaTrash } from "react-icons/fa";

const FormButton = styled(Button)`
  height: 25px;
`;

const CorrectiveEventHolder = styled.div`
  display: flex;
  flex-direction: row;
`;

const CommissionCreationCorrectiveEvent = props => (
  
  <CorrectiveEventHolder>
    <table id="comissionCreateTable">
      {props.index < 1 ? (
        <thead>
          <tr>
            <th> Corrective Disclosure / Adverse Event</th>
            <th style={{paddingLeft:20}}>Percentage</th>
            <th></th>
          </tr>
        </thead>
      ) : null}
      <tbody>
        <tr>
          <td>
            <DatePicker
              placeholderText={"Select date"}
              selected={props.data.date}
              onChange={props.onChange}
              maxDate={props.maxDate}
              dropdownMode={props.dropdownMode}
              className={[
                props.className,
                "commission-corrective-event-input"
              ].join(" ")}
              showYearDropdown
            />
          </td>
          <td>
            <div className="d-flex">
            <div
                className="m-lr-3"
                onClick={() =>
                  props.incrementdecrementValue(props.data.percentage, "minus")
                }
              >
                 <FormButton disabled={[0, "0"].includes(props.data.percentage)}>
                  -
                </FormButton>
              </div>
              <div className={"percentage-div"}>        
                <div >
                    <input
                      value={props.data.percentage}
                      onChange={$event => props.onChangepercentage($event)}
                      className={"percentage-input-div"}
                      placeholder={"%"}
                      pattern="^[0-9]\d*\d*$"
                    />
                </div>
                <div className={"percentage-symbol-div"}>
                    {props.data.percentage!==''?'%':props.data.percentage>0&&'%'}
                </div>
              </div>
              
              <div
                className="m-lr-3"
                onClick={() =>
                  props.incrementdecrementValue(props.data.percentage, "plus")
                }
              >
                <FormButton
                  disabled={[100, "100"].includes(props.data.percentage)}
                >
                  +
                </FormButton>
              </div>
            </div>
          </td>
          <td className="d-flex width3">
            {props.cur_length > 1 ? (
              <FaTrash
                onClick={() => props.remove_corrective_event(props.index)}
                className="editBtn"
              />
            ) : null}
            {props.cur_length===props.index+1?<button
              className="btn add-btn"
              onClick={() => props.add_corrective_event()}
              disabled={props.cur_length === 17}
            >
              Add
            </button>:null}
          </td>
        </tr>
      </tbody>
    </table>
  </CorrectiveEventHolder>
);

export default CommissionCreationCorrectiveEvent;



// WEBPACK FOOTER //
// ./src/commissions/components/CommissionCreationCorrectiveEvent.js